export interface Pdf {
    type: Type;
}

export enum Type {
    Q_AND_A = 'MijnKantoor_Q&A',
    STAPPENPLAN = 'MijnKantoor_stappenplan'
}
